import { render, staticRenderFns } from "./AddCrossPromotion.vue?vue&type=template&id=b7ad26be&scoped=true&"
import script from "./AddCrossPromotion.vue?vue&type=script&lang=js&"
export * from "./AddCrossPromotion.vue?vue&type=script&lang=js&"
import style0 from "./AddCrossPromotion.vue?vue&type=style&index=0&id=b7ad26be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ad26be",
  null
  
)

export default component.exports